<script>
export default {
    name: "galleryInfo",
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="gallery_info">
        <div class="more_info_list layout_main flex justify_between">
            <div class="item">
                <p class="name">A<sup>+</sup> Studio Gallery 艾嘉画廊</p>
                <div class="text">
                    <p>地址：苏州市昆山市花桥镇</p>
                    <p class="indent">晨风路6号东华大学楼3号楼316室</p>
                </div>
            </div>
            <div class="item">
                <p class="name">营业时间</p>
                <div class="text">
                    <p>日&nbsp;&nbsp;&nbsp;常：10：00 - 17：45</p>
                    <p>星期五：10：00 - 22：00</p>
                    <p>请注意展览营业时间以展览告示为准</p>
                </div>
            </div>
            <div class="item">
                <p class="name">免费入场</p>
                <div class="text">
                    <p>一些展览和活动需要单独收费</p>
                    <p><a href="">会员免费参观 —— 立即加入</a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.gallery_info{
    padding: .5rem 0;
    border-top: 1px solid #999;
    @media only screen and (max-width: 750px) {
        padding: .6rem 0;
    }
}
.more_info_list{
    .item{
        line-height: 2;
        .name{
            font-size: .25rem;
            font-weight: bold;
            margin-bottom: .2rem;
        }
        .indent{
            text-indent: 3em;
        }
        .text{
            font-size: .2rem;
            a{
                border-bottom: 1px solid var(--font_color);
            }
        }
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        text-align: center;
        gap: .5rem;
        .item{
            .name{
                font-size: .32rem;
            }
            .indent{
                text-indent: 0;
            }
            .text{
                font-size: .28rem;
                color: #666;
            }
        }
    }
}
</style>